module.exports = __webpack_public_path__ + "img/胡颖.083d8dad.jpg";